<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.processRenewals }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs6>
                          <v-text-field
                            ref="polNoFr"
                            v-model="filters.polNoFr"
                            :label="labels.polNoFr"
                            :error-messages="errors.collect('polNoFr')"
                            data-vv-name="polNoFr"
                            :data-vv-as="labels.polNoFr"
                            v-validate="valPolNoFr"
                            @change="doValPolNoFr"
                            :loading="polNoFrLoading"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="doPolNoFr" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <v-text-field
                            ref="polNoTo"
                            v-model="filters.polNoTo"
                            :label="labels.polNoTo"
                            :error-messages="errors.collect('polNoTo')"
                            data-vv-name="polNoTo"
                            :data-vv-as="labels.polNoTo"
                            v-validate="valPolNoTo"
                            @change="doValPolNoTo"
                            :loading="polNoToLoading"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="doPolNoTo" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <cal-picker
                            v-model="filters.polExpDateFr"
                            :label="labels.polExpDateFr"
                            :error-messages="errors.collect('polExpDateFr')"
                            data-vv-name="polExpDateFr"
                            :data-vv-as="labels.polExpDateFr"
                            v-validate="'required'"
                            @blur="doPolExpDateFr"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <cal-picker
                            v-model="filters.polExpDateTo"
                            :label="labels.polExpDateTo"
                            :error-messages="errors.collect('polExpDateTo')"
                            data-vv-name="polExpDateTo"
                            :data-vv-as="labels.polExpDateTo"
                            v-validate="valPolExpDateTo"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <cal-picker
                            v-model="filters.renPolTranDate"
                            :label="labels.renPolTranDate"
                            :error-messages="errors.collect('renPolTranDate')"
                            data-vv-name="renPolTranDate"
                            :data-vv-as="labels.renPolTranDate"
                            v-validate="doValidateDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 xs6> </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Policy Type -->
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.polType" :label="labels.polType" item-text="label" item-value="value"
                          data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.polType==='Selected'">
                          <v-autocomplete :items="polTypeList" v-model="filters.polTypeSelected" :label="labels.polTypeSelected" item-text="label" item-value="value" multiple
                          data-vv-name="polTypeSelected" :data-vv-as="labels.polTypeSelected" :error-messages="errors.collect('polTypeSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->
                        <!-- Policy Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="filters.polType"
                            :label="labels.polType"
                            :error-messages="errors.collect('polType')"
                            :data-vv-as="labels.polType"
                            data-vv-name="polType"
                            append-icon="mdi-magnify"
                            @click:append="multiPolTypeList = true"
                            readonly
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Exclude Business Class -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="filters.excBusCls"
                            :label="labels.excBusCls"
                            :error-messages="errors.collect('excBusCls')"
                            :data-vv-as="labels.excBusCls"
                            data-vv-name="excBusCls"
                            append-icon="mdi-magnify"
                            @click:append="doExcBusCls"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="noneSelectedList" v-model="filters.excBusCls" :label="labels.excBusCls" item-text="label" item-value="value"
                          data-vv-name="excBusCls" :data-vv-as="labels.excBusCls" :error-messages="errors.collect('excBusCls')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.excBusCls==='Selected'">
                          <v-autocomplete :items="busClsList" v-model="filters.excBusClsSelected" :label="labels.excBusClsSelected" item-text="label" item-value="value" multiple
                          data-vv-name="excBusClsSelected" :data-vv-as="labels.excBusClsSelected" :error-messages="errors.collect('excBusClsSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- 2020-10-30 LYT OK-634 -->
                        <!-- Exclude Agent  -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="filters.excAgent"
                            :label="labels.excAgent"
                            :error-messages="errors.collect('excAgent')"
                            :data-vv-as="labels.excAgent"
                            data-vv-name="excAgent"
                            append-icon="mdi-magnify"
                            @click:append="multiInterList = true"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="noneSelectedList" v-model="filters.excAgent" :label="labels.excAgent" item-text="label" item-value="value"
                          data-vv-name="excAgent" :data-vv-as="labels.excAgent" :error-messages="errors.collect('excAgent')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.excAgent==='Selected'">
                          <v-autocomplete :items="agentList" v-model="filters.excAgentSelected" :label="labels.excAgentSelected" item-text="label" item-value="value" multiple
                          data-vv-name="excAgentSelected" :data-vv-as="labels.excAgentSelected" :error-messages="errors.collect('excAgentSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- Billing Account No. From -->
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="acctNoList" v-model="filters.acctNoFr" :label="labels.acctNoFr" item-text="label" item-value="value"
                          data-vv-name="acctNoFr" :data-vv-as="labels.acctNoFr" :error-messages="errors.collect('acctNoFr')" v-validate="valAcctNoFr"
                          @change="doAcctNoFr" clearable></v-autocomplete>
                        </v-flex> -->
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="filters.acctNoFr"
                            :label="labels.acctNoFr"
                            :error-messages="errors.collect('acctNoFr')"
                            data-vv-name="acctNoFr"
                            :data-vv-as="labels.acctNoFr"
                            append-icon="mdi-magnify"
                            readonly
                            @click:append="
                              showIntermediaryHelpList = true
                              selectedInterField = 'acctNoFr'
                            "
                            clearable
                            v-validate="valAcctNoFr"
                          />
                        </v-flex>
                        <!-- Billing Account No. To -->
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="acctNoList" v-model="filters.acctNoTo" :label="labels.acctNoTo" item-text="label" item-value="value"
                          data-vv-name="acctNoTo" :data-vv-as="labels.acctNoTo" :error-messages="errors.collect('acctNoTo')" v-validate="valAcctNoTo"
                          clearable></v-autocomplete>
                        </v-flex> -->
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="filters.acctNoTo"
                            :label="filters.acctNoTo"
                            :error-messages="errors.collect('acctNoTo')"
                            data-vv-name="acctNoTo"
                            :data-vv-as="labels.acctNoTo"
                            append-icon="mdi-magnify"
                            readonly
                            @click:append="
                              showIntermediaryHelpList = true
                              selectedInterField = 'acctNoTo'
                            "
                            clearable
                            v-validate="valAcctNoTo"
                          />
                        </v-flex>

                        <!-- Agent From -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="agentList"
                            v-model="filters.agentFr"
                            :label="labels.agentFr"
                            item-text="label"
                            item-value="value"
                            data-vv-name="agentFr"
                            :data-vv-as="labels.agentFr"
                            :error-messages="errors.collect('agentFr')"
                            v-validate="valAgentFr"
                            @change="doAgentFr"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <!-- Agent To -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="agentList"
                            v-model="filters.agentTo"
                            :label="labels.agentTo"
                            item-text="label"
                            item-value="value"
                            data-vv-name="agentTo"
                            :data-vv-as="labels.agentTo"
                            :error-messages="errors.collect('agentTo')"
                            v-validate="valAgentTo"
                            clearable
                          ></v-autocomplete>
                        </v-flex>

                        <!-- Account Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="filters.acctType"
                            :label="labels.acctType"
                            :error-messages="errors.collect('acctType')"
                            :data-vv-as="labels.acctType"
                            data-vv-name="acctType"
                            append-icon="mdi-magnify"
                            @click:append="multiAcctTypeList = true"
                            readonly
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.acctType" :label="labels.acctType" item-text="label" item-value="value"
                          data-vv-name="acctType" :data-vv-as="labels.acctType" :error-messages="errors.collect('acctType')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.acctType==='Selected'">
                          <v-autocomplete :items="acctTypeList" v-model="filters.acctTypeSelected" :label="labels.acctTypeSelected" item-text="label" item-value="value" multiple
                          data-vv-name="acctTypeSelected" :data-vv-as="labels.acctTypeSelected" :error-messages="errors.collect('acctTypeSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- Branch -->
                        <!-- Branch -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.branch"
                            :label="labels.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="labels.branch"
                            append-icon="mdi-magnify"
                            @click:append="multiBranchList = true"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.branch" :label="labels.branch" item-text="label" item-value="value"
                          data-vv-name="branch" :data-vv-as="labels.branch" :error-messages="errors.collect('branch')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.branch==='Selected'">
                          <v-autocomplete :items="branchList" v-model="filters.branchSelected" :label="labels.branchSelected" item-text="label" item-value="value" multiple
                          data-vv-name="branchSelected" :data-vv-as="labels.branchSelected" :error-messages="errors.collect('branchSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- Department -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.dept"
                            :label="labels.dept"
                            :error-messages="errors.collect('dept')"
                            :data-vv-as="labels.dept"
                            data-vv-name="dept"
                            append-icon="mdi-magnify"
                            @click:append="multiDeptList = true"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.dept" :label="labels.dept" item-text="label" item-value="value"
                          data-vv-name="dept" :data-vv-as="labels.dept" :error-messages="errors.collect('dept')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.dept==='Selected'">
                          <v-autocomplete :items="deptList" v-model="filters.deptSelected" :label="labels.deptSelected" item-text="label" item-value="value" multiple
                          data-vv-name="deptSelected" :data-vv-as="labels.deptSelected" :error-messages="errors.collect('deptSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- Direct / RI Inwards -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="dRiList"
                            v-model="filters.dRi"
                            :label="labels.dRi"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dRi"
                            :data-vv-as="labels.dRi"
                            :error-messages="errors.collect('dRi')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <!-- Client Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.clientType"
                            :label="labels.clientType"
                            :error-messages="errors.collect('clientType')"
                            :data-vv-as="labels.clientType"
                            data-vv-name="clientType"
                            append-icon="mdi-magnify"
                            @click:append="multiClientTypeList = true"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.clientType" :label="labels.clientType" item-text="label" item-value="value"
                          data-vv-name="clientType" :data-vv-as="labels.clientType" :error-messages="errors.collect('clientType')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.clientType==='Selected'">
                          <v-autocomplete :items="clientTypeList" v-model="filters.clientTypeSelected" :label="labels.clientTypeSelected" item-text="label" item-value="value" multiple
                          data-vv-name="clientTypeSelected" :data-vv-as="labels.clientTypeSelected" :error-messages="errors.collect('clientTypeSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- Insured Reference -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.insdRef"
                            :label="labels.insdRef"
                            :error-messages="errors.collect('insdRef')"
                            :data-vv-as="labels.insdRef"
                            data-vv-name="insdRef"
                            append-icon="mdi-magnify"
                            @click:append="multiInsdRefList = true"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.insdRef" :label="labels.insdRef" item-text="label" item-value="value"
                          data-vv-name="insdRef" :data-vv-as="labels.insdRef" :error-messages="errors.collect('insdRef')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.insdRef==='Selected'">
                          <v-text-field v-model="filters.insdRefSelected" :label="labels.insdRefSelected" :error-messages="errors.collect('insdRefSelected')" data-vv-name="insdRefSelected"
                          :data-vv-as="labels.insdRefSelected" append-icon="mdi-magnify" @click:append="getHelpList('insured')" readonly></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->

                        <!-- Policy Status -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="polStatList"
                            v-model="filters.polStat"
                            :label="labels.polStat"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polStat"
                            :data-vv-as="labels.polStat"
                            :error-messages="errors.collect('polStat')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <!-- Scheme -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.scheme"
                            :label="labels.scheme"
                            :error-messages="errors.collect('scheme')"
                            :data-vv-as="labels.scheme"
                            data-vv-name="scheme"
                            append-icon="mdi-magnify"
                            @click:append="multiSchemeList = true"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-flex lg6 xs6>
                          <v-autocomplete :items="allSelectedList" v-model="filters.scheme" :label="labels.scheme" item-text="label" item-value="value"
                          data-vv-name="scheme" :data-vv-as="labels.scheme" :error-messages="errors.collect('scheme')"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.scheme==='Selected'">
                          <v-autocomplete :items="schemeList" v-model="filters.schemeSelected" :label="labels.schemeSelected" item-text="label" item-value="value" multiple
                          data-vv-name="schemeSelected" :data-vv-as="labels.schemeSelected" :error-messages="errors.collect('schemeSelected')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex> -->
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.processCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- <v-flex xs12>
                          <v-checkbox color="primary" :label="labels.applyAutoRate" v-model="filters.applyAutoRate"></v-checkbox>
                        </v-flex> -->
                        <v-flex xs12>
                          <v-checkbox color="primary" :label="labels.copyPremDue" v-model="filters.copyPremDue"></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox color="primary" :label="labels.copyGAP" v-model="filters.copyGAP"></v-checkbox>
                        </v-flex>
                        <!-- <v-flex xs12>
                          <v-checkbox color="primary" :label="labels.copyGAPBase" v-model="filters.copyGAPBase"></v-checkbox>
                        </v-flex> -->
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-btn color="primary" dark :loading="submitting" @click.prevent="doSubmit">
            {{ labels.generateRenewal }}
            <v-icon dark right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="multiPolTypeList" width="900px" persistent>
      <multi-pol-type-help-list :pt="filters.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiBusClsList" width="900px" persistent>
      <multi-bus-cls-exclude-help-list
        :polType="filters.polType"
        :busCls="filters.excBusCls"
        @close="doClose"
        @doAssign="doAssignBusCls($event)"
      ></multi-bus-cls-exclude-help-list>
    </v-dialog>

    <v-dialog v-model="multiInterList" width="900px" persistent>
      <multi-intermediary-exclude-help-list
        :intr="filters.excAgent"
        intrGrp="10,11"
        helpListTitle="Agent HelpList"
        @close="doClose"
        @doAssign="doAssignIntermediary($event)"
      ></multi-intermediary-exclude-help-list>
    </v-dialog>

    <v-dialog v-model="multiAcctTypeList" width="900px" persistent>
      <multi-acct-type-help-list :acctType="filters.acctType" @close="doClose" @doAssign="doAssignAcctType($event)"></multi-acct-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiBranchList" width="900px" persistent>
      <multi-branch-help-list :brn="filters.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="multiDeptList" width="900px" persistent>
      <multi-dept-help-list :dept="filters.dept" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
    </v-dialog>

    <v-dialog v-model="multiClientTypeList" width="900px" persistent>
      <multi-client-type-help-list
        :clientType="filters.clientType"
        @close="doClose"
        @doAssign="doAssignClientType($event)"
      ></multi-client-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiInsdRefList" width="900px" persistent>
      <multi-insured-help-list :insdRef="filters.insdRef" @close="doClose" @doAssign="doAssignInsdRef($event)"></multi-insured-help-list>
    </v-dialog>

    <v-dialog v-model="multiSchemeList" width="900px" persistent>
      <multi-scheme-help-list :scheme="filters.scheme" @close="doClose" @doAssign="doAssignScheme($event)"></multi-scheme-help-list>
    </v-dialog>

    <!--Policy Help List -->
    <v-dialog v-model="showPolicyHelpList" width="1280px" persistent>
      <policy-renewal-help-list @close="showPolicyHelpList = false" @assign-policy="assignPolicy"></policy-renewal-help-list>
    </v-dialog>

    <v-dialog v-model="showIntermediaryHelpList" width="900px" persistent>
      <intermediary-help-list2
        :interGrps="'10,11,25'"
        @close="showIntermediaryHelpList = false"
        headerInfo="default"
        @assign-intermediary-data="assignInterInfo"
      ></intermediary-help-list2>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class="headline">System Information</div>
            <span class="grey--text">An error occurred.</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Error Details:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="helplist" width="900px" persistent>
      <insuredHelplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></insuredHelplist>
    </v-dialog> -->

    <v-dialog v-model="submitting" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { uwFilters } from '@/mixins/underwriting/uwFilters'
import PolicyRenewalHelpList from '@/components/core/common/dialog/PolicyRenewalHelpList'
import { expandURI } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
// import InsuredHelplist from '@/components/reports/underwriting/InsuredHelplist'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiBusClsExcludeHelpList from '@/components/core/common/dialog/MultiBusClsExcludeHelpList'
import MultiIntermediaryExcludeHelpList from '@/components/core/common/dialog/MultiIntermediaryExcludeHelpList.vue'
import MultiAcctTypeHelpList from '@/components/core/common/dialog/MultiAcctTypeHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiClientTypeHelpList from '@/components/core/common/dialog/MultiClientTypeHelpList.vue'
import MultiInsuredHelpList from '@/components/core/common/dialog/MultiInsuredHelpList.vue'
import MultiSchemeHelpList from '@/components/core/common/dialog/MultiSchemeHelpList.vue'
import IntermediaryHelpList2 from '@/components/core/common/dialog/IntermediaryHelpList2'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        processRenewals: 'Process Renewals',
        polNoFr: 'Policy No. From',
        polNoTo: 'To',
        polExpDateFr: 'Policy Expiry Date From',
        polExpDateTo: 'To',
        renPolTranDate: 'Transaction Date for Renewal Policy',
        selectionCriteria: 'Selection Criteria',
        polType: 'Policy Type',
        excBusCls: 'Exclude Business Class',
        acctNoFr: 'Billing Account No. From',
        acctNoTo: 'To',
        agentFr: 'Agent From',
        agentTo: 'To',
        acctType: 'Intermediary Type',
        branch: 'Branch',
        dept: 'Department',
        dRi: 'Direct / RI Inwards',
        clientType: 'Client Type',
        insdRef: 'Insured Reference',
        polStat: 'Policy Status',
        scheme: 'Scheme',
        processCriteria: 'Processing Criteria',
        applyAutoRate: 'Apply Automatic Rating',
        copyPremDue: 'Copy Premium Due',
        copyGAP: 'Copy Gross Annual Premium',
        copyGAPBase: 'Copy Gross Annual Premium (BASE only)',
        generateRenewal: 'Generate Renewals',
        // polTypeSelected: 'Selected Policy Type',
        // excBusClsSelected: 'Selected Exclude Business Class',
        // acctTypeSelected: 'Selected Account Type',
        // branchSelected: 'Selected Branch',
        // deptSelected: 'Selected Department',
        // clientTypeSelected: 'Selected Client Type',
        // insdRefSelected: 'Selected Insured Reference',
        // schemeSelected: 'Selected Scheme',
        excAgent: 'Exclude Agent' // 2020-10-30 LYT OK-634
        // excAgentSelected: 'Selected Exclude Agent' // 2020-10-30 LYT OK-634
      },
      filters: {
        polNoFr: null,
        polNoTo: null,
        polExpDateFr: null,
        polExpDateTo: null,
        renPolTranDate: null,
        polType: 'All',
        // polTypeSelected: null,
        excBusCls: 'None',
        // excBusClsSelected: null,
        acctNoFr: null,
        acctNoTo: null,
        agentFr: null,
        agentTo: null,
        acctType: 'All',
        // acctTypeSelected: null,
        branch: 'All',
        // branchSelected: null,
        dept: 'All',
        // deptSelected: null,
        dRi: 'Both',
        clientType: 'All',
        // clientTypeSelected: null,
        insdRef: 'All',
        // insdRefSelected: null,
        // insdRefSelectedObj: null,
        polStat: null,
        scheme: 'All',
        // schemeSelected: null,
        applyAutoRate: false,
        copyPremDue: false,
        copyGAP: false,
        copyGAPBase: false,
        excAgent: 'None' // 2020-10-30 LYT OK-634
        // excAgentSelected: null // 2020-10-30 LYT OK-634
      },
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      noneSelectedList: [
        {
          label: 'None',
          value: 'None'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      polTypeList: [],
      busClsList: [],
      acctNoList: [],
      agentList: [],
      acctTypeList: [],
      branchList: [],
      deptList: [],
      dRiList: [
        {
          label: 'Both',
          value: 'Both'
        },
        {
          label: 'Direct',
          value: 'Direct'
        },
        {
          label: 'RI Inwards',
          value: 'Inwards'
        }
      ],
      clientTypeList: [],
      insdRefList: [],
      polStatList: [],
      schemeList: [],
      loading: false,
      polNoHelp: null,
      showErrorDialog: false,
      error: {
        polNoFr: null,
        polNoTo: null
      },
      polNoFrLoading: false,
      polNoToLoading: false,
      submitting: false,
      helplist: false,
      apiURI: '',
      param: '',
      mode: '',
      multiAgentList: false,
      multiPolTypeList: false,
      multiBusClsList: false,
      multiInterList: false,
      multiAcctTypeList: false,
      multiBranchList: false,
      multiDeptList: false,
      multiClientTypeList: false,
      multiInsdRefList: false,
      multiSchemeList: false,
      showIntermediaryHelpList: false,
      trandaterange: {},
      panel1: [0],
      panel2: [0]
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    valPolNoFr() {
      if (
        this.filters.polNoTo !== null &&
        this.filters.polNoTo !== undefined &&
        this.filters.polNoTo !== '' &&
        (this.filters.polNoFr === null || this.filters.polNoFr === undefined || this.filters.polNoFr === '')
      ) {
        return 'required'
      } else if (this.error.polNoFr !== null) {
        return 'valField:' + this.error.polNoFr
      } else {
        return ''
      }
    },
    valPolNoTo() {
      if (
        this.filters.polNoFr !== null &&
        this.filters.polNoFr !== undefined &&
        this.filters.polNoFr !== '' &&
        (this.filters.polNoTo === null || this.filters.polNoTo === undefined || this.filters.polNoTo === '')
      ) {
        return 'required'
      } else if (this.error.polNoTo !== null) {
        return 'valField:' + this.error.polNoTo
      } else {
        return ''
      }
    },
    valPolExpDateTo() {
      if (this.filters.polExpDateFr !== undefined && this.filters.polExpDateFr !== null && this.filters.polExpDateFr !== '') {
        return 'required|start_enddate:' + this.filters.polExpDateFr
      } else {
        return 'required'
      }
    },
    valAcctNoFr() {
      if (
        this.filters.acctNoTo !== null &&
        this.filters.acctNoTo !== undefined &&
        this.filters.acctNoTo !== '' &&
        (this.filters.acctNoFr === null || this.filters.acctNoFr === undefined || this.filters.acctNoFr === '')
      ) {
        return 'required'
      } else {
        return ''
      }
    },
    valAcctNoTo() {
      if (this.filters.acctNoFr !== null && this.filters.acctNoFr !== undefined && this.filters.acctNoFr !== '') {
        return 'required'
      } else {
        return ''
      }
    },
    valAgentFr() {
      if (
        this.filters.agentTo !== null &&
        this.filters.agentTo !== undefined &&
        this.filters.agentTo !== '' &&
        (this.filters.agentFr === null || this.filters.agentFr === undefined || this.filters.agentFr === '')
      ) {
        return 'required'
      } else {
        return ''
      }
    },
    valAgentTo() {
      if (this.filters.agentFr !== null && this.filters.agentFr !== undefined && this.filters.agentFr !== '') {
        return 'required'
      } else {
        return ''
      }
    },
    tDateRange() {
      return this.trandaterange
    },
    doValidateDate() {
      return 'required|valTranDateRange:' + this.tDateRange.effDate + ',' + this.tDateRange.expDate
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])

      this.filters.renPolTranDate = new Date()
      this.filters.polType = 'All'
      this.filters.excBusCls = 'None'
      this.filters.acctType = 'All'
      this.filters.branch = 'All'
      this.filters.dept = 'All'
      this.filters.dRi = 'Both'
      this.filters.clientType = 'All'
      this.filters.insdRef = 'All'
      this.filters.scheme = 'All'
      this.filters.applyAutoRate = false
      this.filters.copyPremDue = false
      this.filters.copyGAP = false
      this.filters.copyGAPBase = false
      this.filters.excAgent = 'None' // 2020-10-30 LYT OK-634

      this.getCommonData('trandaterange', '100')
      this.getParameters()
    },
    async getParameters() {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.initProcessRenewals
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          if (result.data.polTypeList) {
            this.$set(this, 'polTypeList', result.data.polTypeList)
          }

          if (result.data.busClsList) {
            this.$set(this, 'busClsList', result.data.busClsList)
          }

          if (result.data.acctNoList) {
            this.$set(this, 'acctNoList', result.data.acctNoList)
          }

          if (result.data.agentList) {
            this.$set(this, 'agentList', result.data.agentList)
          }

          if (result.data.acctTypeList) {
            this.$set(this, 'acctTypeList', result.data.acctTypeList)
          }

          if (result.data.branchList) {
            this.$set(this, 'branchList', result.data.branchList)
          }

          if (result.data.deptList) {
            this.$set(this, 'deptList', result.data.deptList)
          }

          if (result.data.clientTypeList) {
            this.$set(this, 'clientTypeList', result.data.clientTypeList)
          }

          if (result.data.insdRefList) {
            this.$set(this, 'insdRefList', result.data.insdRefList)
          }

          if (result.data.polStatList) {
            this.$set(this, 'polStatList', result.data.polStatList)
          }

          if (result.data.schemeList) {
            this.$set(this, 'schemeList', result.data.schemeList)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doPolNoFr() {
      this.polNoHelp = 1
      this.showPolicyHelpList = true
    },
    doPolNoTo() {
      this.polNoHelp = 2
      this.showPolicyHelpList = true
    },
    assignPolicy(polNo) {
      if (this.polNoHelp === 1) {
        this.filters.polNoFr = polNo
        // this.$refs.polNoFr.focus()
        this.doValPolNoFr().then(() => {
          if (this.filters.polNoTo === '' || this.filters.polNoTo === undefined || this.filters.polNoTo === null) {
            this.filters.polNoTo = polNo
            this.doValPolNoTo()
          }
        })
      } else {
        this.filters.polNoTo = polNo
        this.doValPolNoTo()
        // this.$refs.polNoTo.focus()
      }

      this.showPolicyHelpList = false
    },
    async doValPolNoFr() {
      if (this.filters.polNoFr !== null && this.filters.polNoFr !== undefined && this.filters.polNoFr !== '') {
        const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.valPolNo
        if (apiUrl) {
          try {
            this.polNoFrLoading = true
            const expand = {
              polNo: this.filters.polNoFr
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.error.polNoFr = null
              this.polNoFrLoading = false
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              // this.message(data)
              if (data.messages.length > 0) {
                this.error.polNoFr = data.messages[0].message
                // 02-05 this.$refs.polNoFr.focus()
              }
            }
            this.polNoFrLoading = false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async doValPolNoTo() {
      if (this.filters.polNoTo !== null && this.filters.polNoTo !== undefined && this.filters.polNoTo !== '') {
        const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.valPolNo
        if (apiUrl) {
          try {
            this.polNoToLoading = true
            const expand = {
              polNo: this.filters.polNoTo
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.error.polNoTo = null
              this.polNoToLoading = false
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              // this.message(data)
              if (data.messages.length > 0) {
                this.error.polNoTo = data.messages[0].message
                // 02-05 this.$refs.polNoTo.focus()
              }
            }
            this.polNoToLoading = false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    doPolExpDateFr() {
      if (
        this.filters.polExpDateFr !== null &&
        this.filters.polExpDateFr !== undefined &&
        this.filters.polExpDateFr !== '' &&
        (this.filters.polExpDateTo === null || this.filters.polExpDateTo === undefined || this.filters.polExpDateTo === '')
      ) {
        this.filters.polExpDateTo = this.filters.polExpDateFr
      }
    },
    doAcctNoFr() {
      if (
        this.filters.acctNoFr !== null &&
        this.filters.acctNoFr !== undefined &&
        this.filters.acctNoFr !== '' &&
        (this.filters.acctNoTo === null || this.filters.acctNoTo === undefined || this.filters.acctNoTo === '')
      ) {
        this.filters.acctNoTo = this.filters.acctNoFr
      }
    },
    doAgentFr() {
      if (
        this.filters.agentFr !== null &&
        this.filters.agentFr !== undefined &&
        this.filters.agentFr !== '' &&
        (this.filters.agentTo === null || this.filters.agentTo === undefined || this.filters.agentTo === '')
      ) {
        this.filters.agentTo = this.filters.agentFr
      }
    },
    doSubmit(value) {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doProcessRenewals()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doProcessRenewals() {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.processRenewals
      if (apiUrl) {
        try {
          this.submitting = true
          // this.filters.insdRefSelected = this.filters.insdRefSelectedObj
          const result = await this.$http.post(apiUrl, this.filters)

          if (result.data) {
            // this.$toast.success('Process Renewals Completed.')
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          // if (this.filters.insdRefSelectedObj != null) {
          //   this.filters.insdRefSelected = this.filters.insdRefSelectedObj.toString()
          // }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    // getHelpList(fieldName) {
    //   this.mode = fieldName
    //   if (fieldName === 'insured') {
    //     this.apiURI = this.$store.state.underwriting.policyHeaderSettings.menu.insuredList
    //     this.param = this.filters.insdRefSelected
    //   }
    //   this.helplist = true
    // },
    doClose() {
      this.helplist = false
      this.multiPolTypeList = false
      this.multiBusClsList = false
      this.multiInterList = false
      this.multiAcctTypeList = false
      this.multiBranchList = false
      this.multiDeptList = false
      this.multiClientTypeList = false
      this.multiInsdRefList = false
      this.multiSchemeList = false
    },
    // doAssign(Obj) {
    //   this.filters.insdRefSelectedObj = Obj.selectedItems
    //   this.filters.insdRefSelected = Obj.selectedItems.toString()
    // if (Obj.selectedItems.length === Obj.totalLength) {
    //   switch (this.mode) {
    //     case 'branch': this.comVoucherForm.branch = 'All'
    //       break
    //     case 'suffix': this.comVoucherForm.excludeAcctNoSfx = 'All'
    //       break
    //   }
    // } else {
    //   switch (this.mode) {
    //     case 'branch': this.comVoucherForm.branch = ''
    //       this.comVoucherForm.branch = Obj.selectedItems.toString()
    //       break
    //     case 'suffix': this.comVoucherForm.excludeAcctNoSfx = 'None'
    //       if (Obj.selectedItems.length === 0) {
    //         this.comVoucherForm.excludeAcctNoSfx = 'None'
    //       } else {
    //         this.comVoucherForm.excludeAcctNoSfx = Obj.selectedItems.toString()
    //       }
    //       break
    //   }
    // }
    // },
    doAssignPolType(Obj) {
      this.filters.polType = []
      this.filters.polType = Obj.finalSelectedItems.toString()
    },
    doAssignBusCls(Obj) {
      this.filters.excBusCls = []
      this.filters.excBusCls = Obj.finalSelectedItems.toString()
    },
    async doAssignIntermediary(Obj) {
      this.filters.excAgent = []
      this.filters.excAgent = Obj.finalSelectedItems.toString()
    },
    async doAssignAcctType(Obj) {
      this.filters.acctType = []
      this.filters.acctType = Obj.finalSelectedItems.toString()
    },
    doAssignBranch(Obj) {
      this.filters.branch = []
      this.filters.branch = Obj.finalSelectedItems.toString()
    },
    async doAssignDepartment(Obj) {
      this.filters.dept = []
      this.filters.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignClientType(Obj) {
      this.filters.clientType = []
      this.filters.clientType = Obj.finalSelectedItems.toString()
    },
    async doAssignInsdRef(Obj) {
      this.filters.insdRef = []
      this.filters.insdRef = Obj.finalSelectedItems.toString()
    },
    async doAssignScheme(Obj) {
      this.filters.scheme = []
      this.filters.scheme = Obj.finalSelectedItems.toString()
    },
    async doExcBusCls() {
      // this.$refs.multiBusClsList.doInit()
      this.multiBusClsList = true
    },
    async assignInterInfo(data) {
      switch (this.selectedInterField) {
        case 'acctNoFr':
          this.filters.acctNoFr = data.inter
          this.$validator.validate('acctNoFr')
          break
        case 'acctNoTo':
          this.filters.acctNoTo = data.inter
          this.$validator.validate('acctNoTo')
          break
        default:
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  created() {
    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        errMsg = errMsg.replace(/%2C/g, ',')
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)

    this.$validator.extend('valTranDateRange', {
      getMessage(field, args) {
        return 'Date is not within permitted Date Range. Please check the Transaction Date Range parameters. (17)'
      },
      validate(value, args) {
        let effDate = args[0]
        let expDate = args[1]
        if (value) {
          return isAfter(removeTime(value), removeTime(effDate)) && !isAfter(removeTime(value), removeTime(expDate))
        } else return true
      }
    })
  },
  mixins: [uwFilters, MessageMixin, commonAjaxMixin],
  components: {
    PolicyRenewalHelpList,
    // InsuredHelplist,
    MultiPolTypeHelpList,
    MultiBusClsExcludeHelpList,
    MultiIntermediaryExcludeHelpList,
    MultiAcctTypeHelpList,
    MultiBranchHelpList,
    MultiDeptHelpList,
    MultiClientTypeHelpList,
    MultiInsuredHelpList,
    MultiSchemeHelpList,
    IntermediaryHelpList2
  }
}
</script>

<style>
</style>
